export enum SubMenu {
  main = 'main',
  scenario = 'scenario',
  section = 'section',
  monster_add = 'monster_add',
  monster_remove = 'monster_remove',
  character_add = 'character_add',
  character_remove = 'character_remove',
  objective_add = 'objective_add',
  objective_remove = 'objective_remove',
  settings = 'settings',
  debug = 'debug',
  server = 'server',
  datamanagement = 'datamanagement',
  editions = 'editions',
  about = 'about',
  campaign = 'campaign'
}
